module.exports = __webpack_public_path__ + "static/img/14000528.b6044514.png";